module.exports = __webpack_public_path__ + "img/0317abb7a5abacfd7752a8869a04ad33.png";